import $ from 'jquery'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';
import {Alert} from '../functions';
import {lockBody, unlockBody} from '../utils';
import Splide from '@splidejs/splide'

const object = vnObject

let noAccountCvPond = FilePond.create(document.querySelector('.js-cv-no-account-input'), {
    acceptedFileTypes: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/png',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template'
    ],
    fileValidateTypeLabelExpectedTypesMap: {
        'application/pdf': '.pdf',
        'application/msword': '.doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
        'image/jpeg': '.jpg, .jpeg',
        'image/png': '.png',
        'application/vnd.oasis.opendocument.text': '.odt',
        'application/vnd.oasis.opendocument.text-template': '.fodt, .ppg'
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
    instantUpload: false
});

$('.js-job-agency').on('click', function (e) {
    if ($(window).width() < 992) {
        e.preventDefault()
        $('#agencyOffcanvas').offcanvas('show');
    }
});

$('#have_cv').on('change', function () {
    if ($(this).is(':checked')) {
        $('.js-cv-input').slideDown();
    } else {
        $('.js-cv-input').slideUp();
    }
});

$('#create_account').on('change', function () {
    if ($(this).is(':checked')) {
        $('.js-password-input').slideDown();
    } else {
        $('.js-password-input').slideUp();
    }
});

const postulateWithoutAccountForm = $('.js-postulate-without-account-form')

if (postulateWithoutAccountForm.length) {
    postulateWithoutAccountForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        let formData = new FormData(postulateWithoutAccountForm[0])

        formData.append('action', 'vn_postulate_without_account')
        formData.append('nonce', object.nonce)

        console.log(noAccountCvPond)
        var pondFiles = noAccountCvPond.getFiles();
            console.log(pondFiles)
        if (pondFiles[0]) {
            console.log(pondFiles[0])
            formData.set('cv', pondFiles[0].file);
        }

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')
                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)
            },
        })
    })
}

const loginForm = $('.js-login-form')

if (loginForm.length) {
    loginForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(loginForm[0])
        formData.append('action', 'vn_login')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')
                if (res.success) {
                    location.reload();
                } else {
                    Alert(res.success, res.data.message)
                }

            },
        })
    })
}

const cvForm = $('.js-cv-form')

if (cvForm.length) {
    cvForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(cvForm[0])
        formData.append('action', 'vn_postulate_cv')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')
                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                } else {
                    Alert(res.success, res.data.message)
                }

            },
        })
    })
}

$('.js-open-postulate-without-account').on('click', function () {
    $('.js-postulate-section').slideUp()
    $('.js-postulate-without-account').slideDown()
})

$('.js-open-not-logged-in').on('click', function () {
    $('.js-postulate-section').slideUp()
    $('.js-not-logged-in').slideDown()
})

$('.js-open-login').on('click', function () {
    $('.js-postulate-section').slideUp()
    $('.js-login').slideDown()
})

$('.js-select-online-cv').on('click', function (e) {
    e.preventDefault()
    $('.js-select-cv').slideDown(0)
    $('.js-cv-container').slideUp(0)
    $(this).slideUp(0)
    $('.js-online-cv').slideDown(0)
    $('#online_cv').prop('checked', true)
})

$('.js-select-pdf-cv').on('click', function (e) {
    e.preventDefault()
    $('.js-select-cv').slideDown(0)
    $('.js-cv-container').slideUp(0)
    $(this).slideUp(0)
    $('.js-pdf-cv').slideDown(0)
    $('#pdf_cv').prop('checked', true)
})

$('.js-select-no-cv').on('click', function (e) {
    e.preventDefault()
    $('.js-select-cv').slideDown(0)
    $('.js-cv-container').slideUp(0)
    $(this).slideUp(0)
    $('.js-no-cv').slideDown(0)
    $('#no_cv').prop('checked', true)
})

$('.js-mobile-postulate-btn').on('click', function (e) {
    if ($(window).width() < 992) {
        $('.js-postulate-modal').fadeIn();
        lockBody()
    }
})

$('.js-close-postulate-mobile').on('click', function (e) {
    if ($(window).width() < 992) {
        $('.js-postulate-modal').fadeOut();
        unlockBody()
    }
})

if (document.body.classList.contains('single-jobs')) {
    const splide = new Splide('.s-jobs__slider', {
        drag: 'free',
        gap: '30px',
        arrows: false,
        pagination: false,
        breakpoints: {
            992: {
                perPage: 1,
            },
        },
    })

    splide.mount()
}

